
import React from 'react'
import Dropdown from 'react-dropdown';
import Row from '../ui/Row'
import Cell from '../ui/Cell'
import Entrance from '../pages/Entrance';
import CommonHelper from '../helpers/CommonHelper';
import MicroEvent  from '../other/microevent';


import Config from '../Config';
import Obtainer from '../helpers/Obtainer';
import { Redirect } from 'react-router-dom';

export default class AuthButton extends React.Component {

  obtainer = Object.create(Obtainer);
  toRefresh = false;

  constructor(props) {
    super(props);

    this.state = {
       options:[{value:-1,label:'Welcome'} ],
       idx:0,
       redirectToReferrer:false,
       dropdownPlaceHolder:'Loading accounts ...',
       refreshId:0,

     };

     this._onSelect = this._onSelect.bind(this)
    MicroEvent.mixin(AuthButton);
    this.bind('reloadSwitchAccountCombo');

    Obtainer.mixin(AuthButton);

    this.bindObtain(
      this.OBTAINS().ACCOUNTS,
      null,
      (arrOfAccounts)=> {console.log(arrOfAccounts); this.populate(arrOfAccounts)},
      null);

    this.bindPeriodicalObtain(
      this.OBTAINS().PURCHASE_ENDTIME,
      null,
      (data)=>{
        if(Entrance.purchaseEndTime() != data['purchase_endtime']){
          //reload (switch yo cur account)
          //this.selectOptionWithAccountId(Entrance.accountId());
          //true to enforce refresh

          //1)
          // Entrance.silentEnter(true);
          // this.toRefresh = true;
          // this.setState({refresh:this.state.refresh++});

          //2)
          //this is looking better than 1)
          this.doSelectOnCombo_forAccountId(Entrance.accountId());
        }
        localStorage.setItem("IDUser",data['IDUser']);
      },
      (error)=>{},
      20
      );
  }

  user_id='';
  GetUserId()
  {

  }
  componentDidMount() {
    this.startObtain(this.OBTAINS().ACCOUNTS);
    this.startObtain(this.OBTAINS().PURCHASE_ENDTIME);
  }

  componentWillUnmount(){
    this.cancelObtain(this.OBTAINS().ACCOUNTS);
    this.cancelObtain(this.OBTAINS().PURCHASE_ENDTIME);
  }

  populate(arrOfAccounts) {
    var dropdownPlaceHolder = (arrOfAccounts.length > 0)?'Select an account':'No accounts linked';
    this.setState({dropdownPlaceHolder:dropdownPlaceHolder});

    var acs = [];
    console.dir(arrOfAccounts);
    var maxLen = dropdownPlaceHolder.length;
    var maxLabel = dropdownPlaceHolder;
    for (var i=0; i < arrOfAccounts.length; i++) {
        var newEl = {};
        newEl['value'] = arrOfAccounts[i].id;
        newEl['label'] = arrOfAccounts[i].login;

        var curLen = newEl['label'].length;
        if(curLen>maxLen){
            maxLen = curLen;
            maxLabel = newEl['label'];
        }

        acs.push(newEl);
    }

    this.setState({options: acs});


    if(acs.length > 0){
      if(CommonHelper.isNull(Entrance.accountId())){
        this._onSelect (acs[0]);
      }else {
        this.selectOptionWithAccountId(Entrance.accountId());
      }
    }


    var dimensions = CommonHelper.calculateWordDimensions(maxLabel);

    this.setState({dropdownOverWidth:''+(dimensions.width + 95) + 'px'});
  }


  selectOptionWithAccountId(accountId) {
    var arrayLength = this.state.options.length;

    for (var i = 0; i < arrayLength; i++)
    {
      var option = this.state.options[i];
      //console.log(option);
      if (option.value == accountId)
      {
        //console.log('equ');
        this.setState({idx: i});
        break;
      }
    }
  }


  onRedirect(){
     this.selectOptionWithAccountId(Entrance.accountId());
  }

  _onSelect (option) {
      Entrance.switchAccount(option.value,
      ()=>{
        this.toRefresh = true;
        this.setState({refresh:this.state.refresh++});
      },
      ()=>{
        this.toRefresh = true;
        this.setState({refresh:this.state.refresh++});
      });
  }

  reloadSwitchAccountCombo() {
    console.log('reloadSwitchAccountCombo');

    this.startObtain(this.OBTAINS().ACCOUNTS);

  }

  componentWillUpdate(nextProps, nextState) {
    if (this.props.authenticationChanged!==nextProps.authenticationChanged)
    {
      this.startObtain(this.OBTAINS().ACCOUNTS);
    }
  }


  doSelectOnCombo_forAccountId(accountId){
    var arrayLength = this.state.options.length;

    for (var i = 0; i < arrayLength; i++)
    {
      var option = this.state.options[i];

      if (option.value == accountId)
      {
        this._onSelect(option);
        break;
      }
    }
  }

  render() {
    var redirect = '';

    if (this.toRefresh){
      this.toRefresh = false;
      redirect = (<div>{this.onRedirect()}<Redirect to={Config.dirHostedAt+'/entrance'}/></div>);

    }

    if (Entrance.isAuthenticated()){

        return (
            <div className='auth-info'>
                {redirect}

                <button className="sc-circle-btn sc-btn-green"
                        onClick={() => window.location.replace(Config.dirHostedAt + '/link_account')}>+
                </button>
                {/*<div>userid {this.GetUserId()}</div>*/}
                <button className="sc-btn sc-btn-red" onClick={() => {
                    Entrance.signout(() => window.location.replace(Config.dirHostedAt + '/login'))
                }}><span>Sign out</span></button>


                <Dropdown baseClassName="HeaderDropdown sc-dropdown--absolute sc-drowpdown--transform sc-dropdown"
                          options={this.state.options} onChange={this._onSelect}
                          value={this.state.options[this.state.idx]} placeholder={this.state.dropdownPlaceHolder}
                          overWidth={this.state.dropdownOverWidth}/>
            </div>
        )
    }else  return (
      <div className='auth-info'>
       <Row>You are not logged in.</Row>  
       </div>
    );
  }

}
